/* VESPR — motion runtime. ~2 KB, no dependency, runs once per page. */
(function () {
  if (window.__vesprMotion) return;
  window.__vesprMotion = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-rv],[data-rv-stagger]').forEach(function (el) {
      el.classList.add('rv-in');
    });
    return;
  }

  /* ---- reveal + stagger + shine + counters, all on one observer ---- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('rv-in');
      if (el.hasAttribute('data-rv-shine')) el.classList.add('rv-shine');
      if (el.hasAttribute('data-rv-count')) countUp(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function watch(root) {
    (root || document)
      .querySelectorAll('[data-rv],[data-rv-stagger],[data-rv-shine],[data-rv-count]')
      .forEach(function (el) {
        if (el.dataset.rvSeen) return;
        el.dataset.rvSeen = '1';
        if (el.hasAttribute('data-rv-stagger')) {
          Array.prototype.forEach.call(el.children, function (c, i) {
            c.style.setProperty('--i', i);
          });
        }
        io.observe(el);
      });
  }

  /* ---- count-up on the numbers that carry the argument ---- */
  function countUp(el) {
    var m = el.textContent.trim().match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m) return;
    var pre = m[1], post = m[3];
    var target = parseFloat(m[2].replace(',', '.'));
    if (isNaN(target)) return;
    var decimals = (m[2].split(/[.,]/)[1] || '').length;
    var dur = 900, t0 = null;
    function tick(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (target * eased).toFixed(decimals) + post;
      if (p < 1) requestAnimationFrame(tick);
    }
    el.textContent = pre + (0).toFixed(decimals) + post;
    requestAnimationFrame(tick);
  }

  /* ---- free-shipping bar: flag "unlocked" so the CSS can react ---- */
  function syncShip() {
    document.querySelectorAll('.vc-ship, #vespr-cfg .ship').forEach(function (bar) {
      var fill = bar.querySelector('.vc-ship__fill, .ship-fill');
      if (!fill) return;
      var pct = parseFloat(fill.style.width) || 0;
      bar.classList.toggle('is-unlocked', pct >= 100);
    });
  }

  /* ---- cart count pop ---- */
  function bump(el) {
    if (!el) return;
    el.classList.remove('vsp-bump');
    void el.offsetWidth;
    el.classList.add('vsp-bump');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button, .btn');
    if (!btn) return;
    var label = (btn.textContent || '').toLowerCase();
    if (label.indexOf('add to cart') === -1 && label.indexOf('upgrade') === -1) return;
    setTimeout(function () {
      bump(document.querySelector('[data-cart-count], .cart-count, .header__cart-count'));
      syncShip();
    }, 320);
  }, true);

  /* ---- boot, and re-scan when the cart drawer injects new nodes ---- */
  function boot() { watch(); syncShip(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  var host = document.getElementById('vespr-cfg') || document.querySelector('.cart-drawer') || document.body;
  new MutationObserver(function () { watch(); syncShip(); })
    .observe(host, { childList: true, subtree: true });

  document.addEventListener('cart:updated', function () { watch(); syncShip(); });
})();
